import { render, staticRenderFns } from "./ShowStatusPedido.vue?vue&type=template&id=9888435a&scoped=true&"
import script from "./ShowStatusPedido.vue?vue&type=script&lang=js&"
export * from "./ShowStatusPedido.vue?vue&type=script&lang=js&"
import style0 from "./ShowStatusPedido.vue?vue&type=style&index=0&id=9888435a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9888435a",
  null
  
)

export default component.exports